"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WordSchema = exports.isAlphabetWord = exports.isSpecialWord = exports.SpecialWordSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const BasicSpecialWordSchema = zod_1.z.object({
    audio_url: zod_1.z.string().optional(),
    id: zod_1.z.string(),
    ipa_txt: zod_1.z.string().optional(),
    is_custom_translation: zod_1.z.boolean().optional(),
    is_extended_word: zod_1.z.boolean().optional(),
    is_special_word: zod_1.z.boolean().optional(),
    known_txt: zod_1.z.string(),
    learn_txt_diacritics: zod_1.z.string().optional(),
    reading: zod_1.z.string().optional(),
    word_learn_gender: zod_1.z.string().optional(),
});
exports.SpecialWordSchema = BasicSpecialWordSchema.extend({
    learn_txt: zod_1.z.string(),
});
exports.isSpecialWord = type_validation_helpers_1.getTypeValidationFunction(exports.SpecialWordSchema);
const AlphabetWordSchema = exports.SpecialWordSchema.and(zod_1.z.object({
    letter_audio_url: zod_1.z.string(),
    letter_ipa_txt: zod_1.z.string(),
    letter_learn_txt: zod_1.z.string(),
    notes: zod_1.z.string().optional(),
}));
const isAlphabetWord = (v) => AlphabetWordSchema.safeParse(v).success;
exports.isAlphabetWord = isAlphabetWord;
exports.WordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    txt: zod_1.z.string(),
});
//# sourceMappingURL=word_types.js.map